import { Reveal } from "@/components/Reveal";

const steps = [
  {
    n: "01",
    title: "Discover",
    body: "We interrogate your business, your customers, and your competitors. Week one ends with a strategy, not a mood board.",
  },
  {
    n: "02",
    title: "Design",
    body: "Art direction and interactive prototypes you can click, not static pictures you have to imagine.",
  },
  {
    n: "03",
    title: "Build",
    body: "Clean execution, weekly check-ins, ruthless QA. You watch the work come alive from day one.",
  },
  {
    n: "04",
    title: "Launch & Grow",
    body: "We ship, measure, and iterate. Launch day is the starting line, and we stay in the race with you.",
  },
];

export const Process = () => (
  <section id="process" className="py-24 md:py-36 bg-foreground text-white" data-testid="process-section">
    <div className="max-w-[1440px] mx-auto px-6 md:px-12">
      <Reveal className="mb-16 md:mb-24">
        <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-white/50 font-medium mb-4">
          Process
        </p>
        <h2 className="font-syne font-bold tracking-tight text-4xl sm:text-5xl">
          Four weeks. Four moves.<br className="hidden md:block" /> No mystery.
        </h2>
      </Reveal>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-white/10 border border-white/10">
        {steps.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.1} className="h-full">
            <div
              className="bg-foreground p-8 md:p-10 h-full hover:bg-[#141414] transition-colors duration-500"
              data-testid={`process-step-${s.n}`}
            >
              <span className="font-syne font-bold text-5xl text-primary">{s.n}</span>
              <h3 className="font-syne font-semibold text-xl tracking-tight mt-8 mb-3">{s.title}</h3>
              <p className="text-sm text-white/60 font-light leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
